import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import layout_es from "./locales/es/layout.json";
import pages_es from "./locales/es/pages.json";
import faq_es from "./locales/es/faq.json";
import legal_es from "./locales/es/legal.json";

import layout_en from "./locales/en/layout.json";
import pages_en from "./locales/en/pages.json";
import faq_en from "./locales/en/faq.json";
import legal_en from "./locales/en/legal.json";

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs:['en','es','de'],
    fallbackLng: 'es',
    resources: {
      es: {
        layout: layout_es,
        pages: pages_es,
        faq: faq_es,
        legal: legal_es,
      },
      en: {
        layout: layout_en,
        pages: pages_en,
        faq: faq_en,
        legal: legal_en,
      },

    },
    detection: {
      order: ['path', 'localStorage', 'sessionStorage'], //'querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'
    },
  });

export default i18next;